import styled from '@emotion/styled';
import { css, IconButton } from '@mui/material';
import { Grid } from '@mui/system';
import { ESize, ESizeThumbnail, ESizeThumbnailSQRT } from 'models/galery';
import { colors } from 'theme/colors';

interface IImageContainerStyled {
  main: boolean;
  sizeImage: ESize;
}

export const ImageContainerStyled = styled(Grid)<IImageContainerStyled>`
  ${(props: IImageContainerStyled) => css`
    background: ${props.main ? colors.primary100 : colors.primary25};
  `}
  align-content: flex-start;
  row-gap: 4px;

  ${(props: IImageContainerStyled) =>
    props.sizeImage === ESize.THUMBNAIL &&
    css`
      width: calc(8px + ${ESizeThumbnail.WIDTH}px);
      min-height: 580px;
    `}
  ${(props: IImageContainerStyled) =>
    props.sizeImage === ESize.THUMBNAIL_SQRT &&
    css`
      width: calc(8px + ${ESizeThumbnailSQRT.WIDTH}px);
      min-height: 440px;
    `}
  height: auto;
  padding: 4px;
  border-radius: 4px;
`;

export const ControlButton = styled(IconButton)`
  width: 24px;
  height: 24px;
  padding: 0;
  border: 1px solid ${colors.primary50};
  background: ${colors.white};
  border-radius: 4px;
  &:hover {
    background: ${colors.primary25};
  }
  &:focus {
    background: ${colors.white};
  }
  &:active {
    background: ${colors.primary700};
    & svg {
      color: ${colors.white};
    }
  }
`;

interface IImagesGalleryContainer {
  sizeImage: ESize;
}

export const ImagesGalleryContainer = styled.div<IImagesGalleryContainer>`
  ${(props: IImagesGalleryContainer) =>
    props.sizeImage === ESize.THUMBNAIL &&
    css`
      width: ${ESizeThumbnail.WIDTH}px;
      height: ${ESizeThumbnail.HEIGHT}px;
      aspect-ratio: ${`${ESizeThumbnail.WIDTH} / ${ESizeThumbnail.HEIGHT}`};
    `}
  ${(props: IImagesGalleryContainer) =>
    props.sizeImage === ESize.THUMBNAIL_SQRT &&
    css`
      width: ${ESizeThumbnailSQRT.WIDTH}px;
      height: ${ESizeThumbnailSQRT.HEIGHT}px;
      aspect-ratio: ${`${ESizeThumbnailSQRT.WIDTH} / ${ESizeThumbnailSQRT.HEIGHT}`};
    `}
display: flex;
  flex-direction: column;
  box-sizing: border-box;
`;

export const ImageStyled = styled.div`
  flex: 1;
  min-height: 0;
  overflow: hidden;
  border-radius: 4px;
  > img {
    object-fit: contain;
    width: 100%;
    height: 100%;
    background: ${colors.white};
  }
`;
